const packageJson = require("../../package.json");
const appVersion = packageJson.version;
const apiVersion = packageJson.apiVersion;

export const environment = {
  production: false,
  isLocal: false,
  name: "UAT",
  auth2FA: false,
  baseAdminUrl: "https://admin.wi.uat.bckpp.com",
  baseApiUrl: "https://api.wi.uat.bckpp.com",
  cdnUrl: "https://inventories.cdn.dev.bckpp.com",
  appVersion,
  apiVersion,
};
